'use client';

import { useCallback } from 'react';
import { useLeaveGuard } from '@/components/ui/dirty-guard';
import { authModel } from '@/models/authModel';

/**
 * Returns the sign-out action. Unsaved work is asked about BEFORE the session ends. The proceed stays
 * pending after the redirect: the guard keeps the unload prompt quiet only while it is running, and
 * WebKit fires beforeunload after the href assignment returns, not inside it. A failed sign-out
 * returns, so the guard re-arms.
 */
export function useSignOut(): () => void {
  const { guard } = useLeaveGuard();
  return useCallback(() => {
    void guard(async () => {
      try {
        await authModel.signOut();
      } catch (error) {
        // Handle error silently
        console.error('Logout failed:', error);
        return;
      }
      window.location.href = '/'; // Force redirect
      await new Promise<never>(() => {});
    });
  }, [guard]);
}
